import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manpowerrecruitment',
  templateUrl: './manpowerrecruitment.component.html',
  styleUrls: ['./manpowerrecruitment.component.css']
})
export class ManpowerrecruitmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
